/**
*@title 일정 안내
*@date 2022-02-09
*@author 홍수희
*@desc
*@etc(change)
*/

import React from 'react';
import { t } from 'i18next';

import { FaHome} from "react-icons/fa";

import CompanySponsorTableFormat from './CompanySponsorTableFormat';

import Clinomics from "../../images_logo_company/Clinomics_Logo_EN.png"
import BMS from "../../images_logo_company/BMS_logo.png"
import PacBio from "../../images_logo_company/mdxk.png"
import helixco from "../../images_logo_company/helixco_logo.svg"
import kobic from "../../images_logo_company/kobic_logo.svg"
import empty from "../../images_logo_company/empty_logo.png"
import bit from "../../images_logo_company/bit.png"
import jcbio from "../../images_logo_company/jcbio.svg"
import daebo from "../../images_logo_company/daebo.jpg"
import supersolution from "../../images_logo_company/supersolution.jpg"

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';

const CompanySponsorTable = () => {
    return(
        <div className="sect-01-box-01-exhibitor-regi">
            <div className="sect-tit">{t("exh_comp_sponsor_title")}</div>
            <div className='exhibitor-comp-spon-tbl-wrap'>
                <div className='tbl-exhibitor-comp-spon'>
                    <div className='inline-block w-full lg:w-11/12 max-w-[1600px]'>
                    <table>
                        <colgroup>
                            <col width="20%"/>
                            <col width="30%"/>
                            <col width="40%"/>
                            <col width="10%"/>
                        </colgroup>
                        <tbody>
                        <tr class="smallCell purple borderUpBoldPurple">
                            <td>
                                {t("exh_comp_sponsor_col1")}
                            </td>
                            <td>
                                {t("exh_comp_sponsor_col2")}
                            </td>
                            <td>
                                {t("exh_comp_sponsor_col3")}
                            </td>
                            <td>
                                {t("exh_comp_sponsor_col4")}
                            </td>
                        </tr>  
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor9_name")} 
                        img = {kobic} 
                        info = {t("exh_comp_sponsor9_info")} 
                        link = ''
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor2_name")} 
                        img = {BMS} 
                        info = {t("exh_comp_sponsor2_info")} 
                        link = 'https://www.bms.kr/main/main.php'
                        />   
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor3_name")} 
                        img = {helixco} 
                        info = {t("exh_comp_sponsor3_info")} 
                        link = 'https://www.helixco.co.kr'
                        />  
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor4_name")} 
                        img = {PacBio} 
                        info = {t("exh_comp_sponsor4_info")} 
                        link = 'http://www.mdxk.co.kr/'
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor5_name")} 
                        img = {bit} 
                        info = {t("exh_comp_sponsor5_info")} 
                        link = 'http://www.b-itsolution.com'
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor6_name")} 
                        img = {jcbio} 
                        info = {t("exh_comp_sponsor6_info")} 
                        link = 'http://jcbio.co.kr/'
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor7_name")} 
                        img = {daebo} 
                        info = {t("exh_comp_sponsor7_info")} 
                        link = 'https://www.dbcs.co.kr'
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor8_name")} 
                        img = {supersolution} 
                        info = {t("exh_comp_sponsor8_info")} 
                        link = 'https://www.supersolution.co.kr'
                        />    
                        <CompanySponsorTableFormat 
                        name={t("exh_comp_sponsor1_name")} 
                        img = {Clinomics} 
                        info = {t("exh_comp_sponsor1_info")} 
                        link = 'https://clinomics.com/ko/'
                        />  
                        </tbody>
                    </table>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CompanySponsorTable;